export default {
  isTwoFaEnabled: (state) => state.isTwoFaEnabled,
  qrDataUrl: (state) => state.qrDataUrl,
  secretKey: (state) => state.secretKey,
  isLoading: (state) => state.isLoading,
  message: (state) => state.message,
};
